/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const banquetTaskImportConfig = () => {
  return axios.get(`${base}/banquet_task/import_config`)
}

export const banquetTaskImport = params => {
  return axios.post(`${base}/batch_jobs/batch_import_banquet_task`, params)
}

export const banquetTaskQuery = params => {
  return axios.post(`${base}/banquet_task/query`, params)
}

export const banquetTaskGet = id => {
  return axios.get(`${base}/banquet_task/${id}`)
}

export const banquetTaskByTask = params => {
  return axios.get(`${base}/banquet_task/by_task_${params.id}`)
}



// WEBPACK FOOTER //
// ./src/views/banquet-task/banquet-task.api.js